<template>
  <path
    class="left"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 10C11.3431 10 10 11.3431 10 13V21C10 22.6569 11.3431 24 13 24H16V18.5C16 17.1193 17.1193 16 18.5 16H24V13C24 11.3431 22.6569 10 21 10H13Z"
    fill="currentColor"
  />
  <path
    class="right"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 24V27C16 28.6569 17.3431 30 19 30H27C28.6569 30 30 28.6569 30 27V19C30 17.3431 28.6569 16 27 16H24V21.5C24 22.8807 22.8807 24 21.5 24H16Z"
    fill="currentColor"
  />
</template>
